import { css } from '@/styled-system/css';

export const comboboxLoadingStateStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBlock: 'Combobox.Option.padding.vert',
  paddingInline: 'Combobox.Option.padding.horz',
});
